import React from "react";
import Container from "../../../components/Container/Container";
import FraisForm from "../../../components/Frais/FraisFrom";
import { useForm } from "react-hook-form";
import swal from "sweetalert";
import { API } from "../../../constants/env";

const AddFrais = () => {
  const { register, handleSubmit, errors, reset } = useForm();

  const onSubmit = (data) => {
    try {
      fetch(API.fees.create, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": localStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((response) => {
          if (response.error) {
            return swal("Error fel request", response.message, "error");
          }
          return swal("Good", "frais Ajouté", "success");
        })
        .catch((e) => {
          return swal(
            "Failed",
            "Something went wrong! check the server ",
            "error"
          );
        });
    } catch (error) {
      return swal("Failed", error.message, "error");
    }
  };

  return (
    <Container name="Ajouter Fees" back={true} backRoute="/fees" submit={true}>
      <FraisForm
        registerRequired={register({ required: true })}
        register={register}
        errors={errors}
        handleSubmit={handleSubmit}
        onSubmit={onSubmit}
        reset={reset}
      />
    </Container>
  );
};

export default AddFrais;
